const en = {
  brand: {
    name: 'Črna Kuhna',
    tagline: 'From the fire. From Prlekija. For the shared table.',
    region: 'Vinski Vrh · Miklavž pri Ormožu',
  },
  photo: {
    badge: 'Authentic photograph',
  },
  nav: {
    home: 'Home',
    story: 'Story',
    menu: 'Menu',
    wines: 'Wines',
    gallery: 'Gallery',
    visit: 'Visit',
    events: 'Events',
    gift: 'Gift vouchers',
  },
  cta: {
    reserve: 'Book a table',
    menu: 'View menu',
    call: 'Call us',
    email: 'Email us',
    directions: 'Open directions',
    inquire: 'Send an enquiry',
    back: 'Back home',
  },
  contact: {
    phone: '+386 71 825 143',
    phoneHref: '+38671825143',
    email: 'crnakuhna.mb@gmail.com',
    addressLine1: 'Vinski Vrh 6',
    addressLine2: '2275 Miklavž pri Ormožu, Slovenia',
    mapsQuery: 'Vinski Vrh 6, 2275 Miklavž pri Ormožu, Slovenia',
  },
  lang: {
    label: 'Language',
    sl: 'Slovenščina',
    en: 'English',
  },
  footer: {
    tagline: 'From the fire. From Prlekija. For the shared table.',
    linksTitle: 'Links',
    contactTitle: 'Contact',
    visitTitle: 'Visit',
    hoursNote: 'Open Thursday to Sunday; closed Monday to Wednesday.',
    rights: 'All rights reserved.',
    notFoundTitle: 'Page not found',
    notFoundText: 'This page could not be found. Return home and try again.',
  },
};

export default en;